import auth from "../../middlewares/auth";
export const faqRoute = [
  {
    path: '/faq/category/list',
    component: () => import(/* webpackChunkName: "faqs" */ '../../views/faqCategory/FaqCategoryList'),
    name: 'faq_category_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/faq/category/add',
    component: () => import(/* webpackChunkName: "faqs" */ '../../views/faqCategory/FaqCategoryForm'),
    name: 'faq_category_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/faq/category/edit/:id',
    component: () => import(/* webpackChunkName: "faqs" */ '../../views/faqCategory/FaqCategoryForm'),
    name: 'faq_category_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/faq/list',
    component: () => import(/* webpackChunkName: "faqs" */ '../../views/faqs/FaqList'),
    name: 'faq_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/faq/add',
    component: () => import(/* webpackChunkName: "faqs" */ '../../views/faqs/FaqForm'),
    name: 'faq_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/faq/edit/:id',
    component: () => import(/* webpackChunkName: "faqs" */ '../../views/faqs/FaqForm'),
    name: 'faq_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];